import {
  Component,
  Input,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { AirWeightBracketName } from "app/shared/air-weight-bracket/air-weight-bracket-name.type.const";
import { airWeightBracket } from "app/shared/air-weight-bracket/air-weight-bracket.const";
import { getWeightBracketsHeader } from "../../../shared/weight-brackets/get-weight-bracket-header.function";
import { Bind } from "primeng/bind";
import { MultiSelect } from "primeng/multiselect";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-air-weight-bracket-select",
  templateUrl: "./air-weight-bracket-select.component.html",
  styleUrls: ["./air-weight-bracket-select.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, MultiSelect, FormsModule],
})
export class AirWeightBracketSelectComponent implements OnInit {
  @Input() label = "Weight brackets";
  readonly appendTo = input("body");
  readonly disabled = input(false);
  readonly required = input(false);
  @Input() selectedWeightBrackets: AirWeightBracketName[] = [];
  readonly selectionChange = output<AirWeightBracketName[]>();

  public weightBracketList;

  constructor() {}

  ngOnInit() {
    this.buildList();
  }

  public onSelectionChange() {
    this.selectionChange.emit(this.getSortedSelection());
  }

  private buildList() {
    const weightBracketNames = <AirWeightBracketName[]>(
      Object.keys(airWeightBracket)
    );
    this.weightBracketList = weightBracketNames.map((weightBracketName) => ({
      label: getWeightBracketsHeader(weightBracketName),
      value: weightBracketName,
    }));
  }

  private getSortedSelection(): AirWeightBracketName[] {
    const sortedList: AirWeightBracketName[] = [];
    this.weightBracketList.map((element) => {
      if (this.selectedWeightBrackets.indexOf(element.value) !== -1) {
        sortedList.push(element.value);
      }
    });

    return sortedList;
  }
}
